import React from 'react';

const Footer = () => {
    return (
        <footer>
            <p>Designed &amp; Developped by <a href="https://naweed-sufranj.fr/" target="_blank" rel="noopener noreferrer">Naweed SUFRANJ</a></p>
            <p>source code here :  <a href="https://github.com/SufranjNaweed/timer-task" target="_blank" rel="noopener noreferrer">https://github.com/SufranjNaweed/timer-task</a></p>
        </footer>
    );
}

export default Footer;